import { ECourseStatus } from '@constants';
import { ICourse } from '@sdk/contracts';
import { Popconfirm } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SectionTitleWrapper } from '../Info.styles';

import { ButtonsWrapper, Wrapper } from './InfoActions.styles';

import { ActionButton } from '@/components/ActionButton';
import { useCourseDuplicator } from '@/hooks';
import { useCourseForm, useMutateCourses, useProfile } from '@/store';

type Props = {
  course: ICourse;
};

export const InfoActions: React.FC<Props> = ({ course }) => {
  const { t } = useTranslation('CourseTranslations');
  const navigateTo = useNavigate();
  const { setCourseToDuplicate } = useCourseDuplicator();
  const { updateCourse, isWorking, removeCourse } = useMutateCourses();
  const { setIsFormOpen } = useCourseForm();
  const {
    roleCheck: { isTeacher, isInspector }
  } = useProfile();

  const handleDuplicate = () => setCourseToDuplicate(course._id);

  const handleRemoveCourse = () => {
    removeCourse(course._id, {
      onSuccess: () => navigateTo('/content/courses')
    });
  };

  const toggleArchive = () =>
    updateCourse({
      _id: course._id,
      status:
        course.status === ECourseStatus.ARCHIVED ? ECourseStatus.DRAFT : ECourseStatus.ARCHIVED
    });

  const isDisabled = isTeacher || isInspector;

  return (
    <Wrapper>
      <ButtonsWrapper>
        <SectionTitleWrapper>{t('ACTIONS')}</SectionTitleWrapper>
        <ActionButton
          loading={isWorking}
          name={t('EDIT_INFORMATION')}
          disabled={isDisabled}
          icon="Edit"
          onClick={() => setIsFormOpen(true)}
        />
        <ActionButton
          loading={isWorking}
          name={t('DUPLICATE_COURSE')}
          disabled={isDisabled}
          icon="Copy"
          onClick={handleDuplicate}
        />
        <ActionButton
          loading={isWorking}
          name={
            course.status === ECourseStatus.ARCHIVED ? t('UNARCHIVE_COURSE') : t('ARCHIVE_COURSE')
          }
          icon="Folders"
          disabled={isDisabled}
          onClick={toggleArchive}
        />
      </ButtonsWrapper>
      <Popconfirm
        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
        disabled={isDisabled}
        onConfirm={handleRemoveCourse}
        title={t('DELETE_COURSE_CONFIRMATION')}>
        <div>
          <ActionButton
            danger
            disabled={isDisabled}
            loading={isWorking}
            name={t('DELETE_COURSE')}
            icon="TrashCan"
            onClick={() => {}}
          />
        </div>
      </Popconfirm>
    </Wrapper>
  );
};
